import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { MapPin, ClipboardList, Tag, ChevronRight } from "lucide-react";

const TILES = [
  {
    key: "bin-assign",
    label: "Bin Assign",
    desc: "Scan products onto shelves",
    icon: MapPin,
    to: "/mobile/bin-assign",
    color: "bg-purple-600",
  },
  {
    key: "stock-count",
    label: "Stock Count",
    desc: "Count sessions & shared scans",
    icon: ClipboardList,
    to: "/mobile/stock-count",
    color: "bg-blue-600",
  },
  {
    key: "price-check",
    label: "Price Check",
    desc: "Look up a product on the floor",
    icon: Tag,
    to: "/mobile/price-check",
    color: "bg-emerald-600",
  },
];

export default function MobileHome() {
  const navigate = useNavigate();
  return (
    <div className="p-4 space-y-3 max-w-md mx-auto" data-testid="mobile-home">
      <div className="mb-2">
        <h2 className="text-lg font-bold text-slate-900">What are you doing?</h2>
        <p className="text-xs text-slate-500">Tap a task to begin.</p>
      </div>
      {TILES.map((t) => {
        const Icon = t.icon;
        return (
          <Card
            key={t.key}
            onClick={() => navigate(t.to)}
            className="p-4 flex items-center gap-4 cursor-pointer active:scale-[0.98] transition hover:shadow-md"
            data-testid={`mobile-tile-${t.key}`}
          >
            <div className={`${t.color} w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0`}>
              <Icon className="h-7 w-7 text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-slate-900">{t.label}</div>
              <div className="text-xs text-slate-500">{t.desc}</div>
            </div>
            <ChevronRight className="h-5 w-5 text-slate-400" />
          </Card>
        );
      })}
    </div>
  );
}
